import axios from 'axios';

export function advertiserSignup(payload) {
    return axios.post(`${process.env.REACT_APP_API_URL}/advertiser/signup`, payload);
}
